module.exports = __webpack_public_path__ + "img/example8.3a2a39f1.jpg";